import { combineReducers } from "redux";
import { addPackageReducer } from './addPackage';
import { editPackageReducer } from './editPackage';
import { addSubPackageReducer } from './addSubPackage';
import { listReducer } from './listPackages';
import { archivedPackagesReducer } from './archievedPackages';

const reducer = combineReducers({
    list: listReducer,
    editPackage: editPackageReducer,
    addPackage: addPackageReducer,
    addSubPackage: addSubPackageReducer,
    archivedPackages: archivedPackagesReducer,
})

export default reducer;